import type { ExternalBooking } from 'patient-api-lib'
import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/Button/Button'
import { Card } from '@/components/Card'
import { RouterPath } from '@/models/enums'
import { activityTrackingService } from '@/services/ActivityTrackingService'

import BookingCard from '../BookingCard/BookingCard'

type MyNextVisitCardProps = {
  nextBooking: ExternalBooking.AsObject | null
  refetch: () => void
  className?: string
  loading?: boolean
  error?: boolean
}

const MyNextVisitCard: FC<MyNextVisitCardProps> = (props) => {
  const { nextBooking, className = '', loading, error, refetch } = props
  const { t } = useTranslation('my-next-visit-card')
  const navigate = useNavigate()

  const handleClickButton = () => {
    activityTrackingService.trackRescheduleButtonClick('next_visit_card')
    if (nextBooking?.reschedulable) {
      navigate(`/${RouterPath.Hub}/${RouterPath.MyBookings}?bookingId=${nextBooking?.id}`)
    }
  }

  return (
    <Card title={t('title')} className={className}>
      <BookingCard booking={nextBooking} loading={loading} error={error} onRetry={refetch} />
      {nextBooking?.reschedulable && (
        <div className="mt-4">
          <Button className="ml-auto h-auto w-[114px] uppercase" onClick={handleClickButton}>
            {t('action_button')}
          </Button>
        </div>
      )}
    </Card>
  )
}

export default MyNextVisitCard
